import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { Session } from "../models/session.model";
import { User } from "../models/user.model";
import { ADMIN_ROLES } from "../core/auth/roles-url";

@Injectable()
export class StorageService {

  private localStorageService;

  constructor(
    private router: Router,
  ) {
    this.localStorageService = localStorage;
  }

  setCurrentSession(session: Session): void {
    this.localStorageService.setItem('currentUser', JSON.stringify(session));
  }

  loadSessionData(): Session {
    var sessionStr = this.localStorageService.getItem('currentUser');
    return (sessionStr) ? <Session>JSON.parse(sessionStr) : null;
  }

  removeCurrentSession(): void {
    this.localStorageService.removeItem('currentUser');
  }

  getCurrentUser(): User {
    var session: Session = this.loadSessionData();
    return (session && session.user) ? session.user : null;
  };

  getEntityUser(): number {
    var user: User = this.getCurrentUser();
    return (user && user.entityId) ? user.entityId : null;
  };

  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null) ? true : false;
  };

  getCurrentToken(): string {
    var session = this.loadSessionData();
    return (session && session.token) ? session.token : null;
  };

  hasRole(role: string | string[]): boolean {
    // Si no se especifica rol, permitir acceso (público)
    if (!role) {
      return true;
    }

    // Si es un string, convertir a array
    const roles = Array.isArray(role) ? role : [role];

    return this.hasAnyRole(roles);
  }

  hasAnyRole(roles: string[]): boolean {
    const user: User = this.getCurrentUser();

    // Si no se especifican roles, consideramos acceso público
    if (!roles || roles.length === 0) {
      return true;
    }

    // Si el usuario no existe o no tiene roles, denegamos acceso
    if (!user || !user.authorities || user.authorities.length === 0) {
      return false;
    }

    // Comprobamos si al menos uno de los roles está presente
    return user.authorities.some(auth => roles.includes(auth.authority));
  }

  isUserAdmin(): boolean {
    return this.hasAnyRole(ADMIN_ROLES);
  };

  isUserGod(): boolean {
    return this.hasRole('ROLE_DES_GOD');
  };

  logout(): void {
    this.removeCurrentSession();
    this.router.navigate(['/login']);
  }
}
